// <div data-controller="admin--llm--article">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [
    "prediction",
    "predictionLatency",
    "predictionGcp",
    "predictionLatencyGcp",
    "predictLoader",
    "predictButton",
  ];
  static classes = [];
  static outlets = ["admin--llm--prompts"];
  static values = {
    articleParams: Object,
  };

  initialize() {}

  async predictGcp() {
    const { picture_ids } = this.articleParamsValue;

    this.predictButtonTarget.classList.add("hidden");
    this.predictLoaderTarget.classList.remove("hidden");

    const imageCountToInclude =
      this.adminLlmPromptsOutlet.imageCountToIncludeTarget.value; // Retrieve the value

    console.log("(2) imageCountToInclude:", imageCountToInclude);

    return api
      .post("/admin/llm/article_prompt/predict", {
        picture_ids: picture_ids,
        system_prompt: this.adminLlmPromptsOutlet.systemPromptTarget.value,
        user_prompt: this.adminLlmPromptsOutlet.userPromptTarget.value,
        use_gcp: true,
        image_count_to_include: imageCountToInclude, // Pass it in the payload
      })
      .then((response) => {
        this.predictButtonTarget.classList.remove("hidden");
        this.predictLoaderTarget.classList.add("hidden");
        this.predictionGcpTarget.innerText = response.data.prediction;

        this.predictionLatencyGcpTarget.innerText = `${response.data.latency.toFixed(
          2
        )}s`;
      })
      .catch((error) => {
        this.predictButtonTarget.classList.remove("hidden");
        this.predictLoaderTarget.classList.add("hidden");
        console.log(error.response.data);
        this.predictionTarget.innerText = error.response.data.split("\n")[0];
      });
  }

  connect() {}

  disconnect() {}
}
